import React from 'react'
import { getLocaleName } from '../../i18n/I18nContext'
import type { LandingLocale } from './landingContent'

type LandingNavCopy = {
  nav: string[]
  signIn: string
}

type LandingNavProps = {
  copy: LandingNavCopy
  appHref: string
  locale: LandingLocale
  onLocaleChange: (locale: LandingLocale) => void
  navAnchors?: string[]
  showRelatedPages?: boolean
}

const defaultNavAnchors = ['#top', '#problem-solution', '#comparison', '#roi', '#contact']
const publicPages = [
  ['Workforce', '/workforce-management-software'],
  ['Construction', '/construction-workforce-management'],
  ['Staffing', '/staffing-agency-software'],
  ['Attendance', '/geofenced-attendance-tracking'],
]
const publicSupportedLocales: LandingLocale[] = ['en', 'fr', 'ar']

export const LandingNav: React.FC<LandingNavProps> = ({ copy, appHref, locale, onLocaleChange, navAnchors = defaultNavAnchors, showRelatedPages = true }) => {
  return (
    <header className="landing-nav">
      <div className="container landing-nav__inner">
        <a className="landing-brand" href="#top" aria-label="NexusWorkforce360">
          <img src="/landing/nexusworkforce360-logo.svg" alt="NexusWorkforce360" className="landing-brand__logo" />
        </a>
        <nav className="landing-nav__links" aria-label="NexusWorkforce360 navigation">
          {copy.nav.map((item, index) => (
            <a key={item} href={navAnchors[index]}>{item}</a>
          ))}
          {showRelatedPages ? publicPages.map(([label, href]) => (
            <a key={href} href={href}>{label}</a>
          )) : null}
        </nav>
        <div className="landing-nav__actions">
          <label className="sr-only" htmlFor="landing-language-select">Language</label>
          <select
            id="landing-language-select"
            className="input landing-language"
            value={locale}
            aria-label="Language"
            onChange={(event) => onLocaleChange(event.target.value as LandingLocale)}
          >
            {publicSupportedLocales.map((item) => (
              <option key={item} value={item}>{getLocaleName(item)}</option>
            ))}
          </select>
          <a className="btn btn-secondary" href={appHref}>{copy.signIn}</a>
        </div>
      </div>
    </header>
  )
}
